export const ROLES = {
    //Employee: 'Employee',
    Miami: 'Miami',
    Tampa: 'Tampa',
    FTL: 'Ftl',
    Seattle: 'Seattle',
    Admin: 'Admin',
    SuperAdmin: 'Super'
}